module.exports = __webpack_public_path__ + "img/portuguessBanner.d2fb49e3.jpeg";